/**
 * Отдельный vuex модуль для взаимодействия по user_links-API
 */

// actions для users. Вызов действия начинать с "users/"
export const ACTION_LOAD_CHILD_LINKS = "LOAD_CHILD_LINKS";
export const ACTION_ADD_CHILD_LINKS = "ADD_CHILD_LINKS";
export const ACTION_DELETE_CHILD_LINKS = "DELETE_CHILD_LINKS";
export const ACTION_LOAD_PARENT_LINKS = "LOAD_PARENT_LINKS";
export const ACTION_DELETE_PARENT_LINKS = "DELETE_PARENT_LINKS";
export const ACTION_LOAD_USER_TOKENS = "LOAD_USER_TOKENS";
export const ACTION_CREATE_USER_TOKEN = "CREATE_USER_TOKEN";
export const ACTION_DELETE_USER_TOKEN = "DELETE_USER_TOKEN";

/**
 * Перечисление констант с названиями всех полей.
 */
export const FIELDS_USER_LINK = Object.freeze({
  "user_id": "user_id",
  "username": "username",
  "date": "date",
});
export const FIELDS_USER_TOKEN = Object.freeze({
  "id": "id",
  "username": "username",
  "body": "body",
});

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    /**
     * Загрузка списка дочерних связей учетной записи.
     *
     * @return {Promise}
     */
    async [ACTION_LOAD_CHILD_LINKS]() {
      const response = await this.getters.ajaxClient.post("/v0/user_links/child/");
      return response.data;
    },
    /**
     * Добавление связи, требуется передать логин и пароль учетной записи.
     *
     * @param {String} username
     * @param {String} password
     * @return {Promise}
     */
    async [ACTION_ADD_CHILD_LINKS](context, {username, password}) {
      try {
        await this.getters.ajaxClient.post("/v0/user_links/child/add/", {
          username,
          password,
        });
      } catch (error) {
        throw Object.values(error.response.data.error).join("");
      }
    },
    /**
     * Удаление связи с дочерней учетной записью.
     *
     * @param {Object} context
     * @param {Number} childId
     * @return {Promise}
     */
    async [ACTION_DELETE_CHILD_LINKS](context, childId) {
      try {
        await this.getters.ajaxClient.post("/v0/user_links/child/delete/", {user_id: childId});
      } catch (error) {
        throw Object.values(error.response.data.error).join("");
      }
    },
    //Parent_________________________________________________________________________________________________________
    /**
     * Загрузка списка родительских связей учетной записи.
     *
     * @return {Promise}
     */
    async [ACTION_LOAD_PARENT_LINKS]() {
      const response = await this.getters.ajaxClient.post("/v0/user_links/parent/");
      return response.data;
    },
    /**
     * Удаление связи с родительской учетной записью.
     *
     * @param {Object} context
     * @param {Number} parentId
     * @return {Promise}
     */
    async [ACTION_DELETE_PARENT_LINKS](context, parentId) {
      try {
        await this.getters.ajaxClient.post("/v0/user_links/parent/delete/", {user_id: parentId});
      } catch (error) {
        throw Object.values(error.response.data.error).join("");
      }
    },
    // Работа с токенами доступа
    async [ACTION_LOAD_USER_TOKENS]() {
      const response = await this.getters.ajaxClient.post("/v0/tokens/long/", {
        fields: [
          FIELDS_USER_TOKEN.id,
          FIELDS_USER_TOKEN.body,
          FIELDS_USER_TOKEN.username
        ]
      });
      return response.data.results[0];
    },
    async [ACTION_CREATE_USER_TOKEN]() {
      const response = await this.getters.ajaxClient.post("/v0/tokens/long/create/",{});
      return response.data;
    },
    async [ACTION_DELETE_USER_TOKEN](context, {ids}) {
      const response = await this.getters.ajaxClient.post("/v0/tokens/long/delete/", {
        ids
      });
      return response.data.results;
    },
  }
};
